const routes = [
    {
        path: "/pos/return/days",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "posreturnday_index"
        },
    }
]

export default routes;
